.mediaPreview {
  border-radius: 10px;
  border: 1px solid var(--dark-4);
  overflow: hidden;
  position: relative;
  max-width: 100%;
  cursor: pointer;
  outline: none;

  img,
  video {
    display: block;
    width: 100%;
    height: auto;
  }

  img {
    object-fit: contain;
  }
}

.mediaContainer {
  display: flex;
  justify-content: center;
  align-items: center;

  img,
  video {
    max-width: 100%;
    max-height: 60vh;
    object-fit: contain;
  }
}
